







































































import Vue from 'vue';
import TopBar from '@/components/widgets/TopBar.vue';
import Preloader from '@/components/preloader/Preloader.vue';
// TODO: Будет добавлено позже
// import FieldCheckbox from '@/components/form/FieldCheckbox.vue';
import Button from '@/components/form/Button.vue';
import SettingsTab from '@/components/groups/SettingsTab.vue';
import { ICollectionTabsData } from '@/types';
import Tabs from '@/components/widgets/Tabs.vue';
import { ICampaignGroup } from '@/types/campaign/groups';
import filterParams from '@/components/table/utils/filterParameters';

export default Vue.extend({
  name: 'CampaignGroupForm',
  components: {
    TopBar,
    Preloader,
    // FieldCheckbox,
    Button,
    SettingsTab,
    Tabs,
  },
  props: {
    title: {
      type: String,
      default: '',
    },
  },

  destroyed() {
    this.$store.dispatch('campaignGroups/clearGroup');
  },

  computed: {
    group(): ICampaignGroup {
      return this.$store.state.campaignGroups.group;
    },
    checkFormStatus(): number {
      return this.group?.status?.value == 'active' ? 1 : 0;
    },
    routerBack(): string {
      const backUrl = filterParams.getUrlBack() || '';
      this.$emit('setBackUrl');
      return backUrl;
    },
    isSavingForm(): boolean {
      return this.$store.state.campaignGroups.isSavingForm;
    },
  },
  methods: {
    submitForm() {
      this.$emit('submit');
    },

    closeForm() {
      this.$router.push(this.routerBack);
    },

    statusChange(statusValue) {
      const status = {
        label: 'Active',
        value: 'active',
      };

      if (!statusValue) {
        status.label = 'Draft';
        status.value = 'draft';
      }

      this.changeGroup({ name: 'status', value: { ...status } });
    },

    changeGroup(payload) {
      this.$store.dispatch('campaignGroups/changeGroup', payload);
    },
  },
  data() {
    return {
      activeTab: 'settings',
      tabsName: {
        settings: {
          name: this.$t('pages.campaignGroupForm.tabs.options.tabName'),
          tab: 'settings',
          isCheck: false,
          isValid: true,
          buttons: true,
        },
      } as ICollectionTabsData,
    };
  },
});
